import { useState, useRef, useEffect } from 'react';

import { Controller } from 'libs/control';
import { CollectionGrid } from './grid';

const sortInitial = [{ field_name: 'role_id', direction: 'desc' }];
const itemsInitial = {};

export const Collection = (props) => {
  const [items, setItems] = useState(itemsInitial);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [sortParams, setSortParams] = useState(sortInitial);
  const mounted = useRef(false);

  // tariffs
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  // grid actions
  const gridActions = {
    addEntries: (data) => {
      if (!mounted.current) {
        return;
      }
      setItems({ ...items, ...data });
    },
    updateEntry: (id, data) => {
      if (!mounted.current) {
        return;
      }

      const newItems = { ...items };
      newItems[id] = { ...newItems[id], ...data };
      setItems(newItems);
    },
    clearEntries: () => {
      if (!mounted.current) {
        return;
      }

      setItems(itemsInitial);
    },
    setSortParams: (data) => {
      if (!mounted.current) {
        return;
      }

      setSortParams(data);
    },
    setOffset: (val) => {
      if (!mounted.current) {
        return;
      }

      setOffset(val);
    },
    setCount: (val) => {
      if (!mounted.current) {
        return;
      }

      setCount(val);
    },
  };

  // grid params
  const gridParams = {
    entries: items,
    offset,
    count,
    sortParams,
  };

  return <Controller {...props} {...gridParams} {...gridActions} type="collection" grid={CollectionGrid} />;
};
